import React from 'react';
import { Avatar, Card, CardHeader, Stack, Typography } from '@mui/material';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import NotFound from './NotFound';

export default function Users({ type, users }) {
  if (users.length === 0) {
    return <NotFound />;
  }

  return (
    <Stack rowGap={0.5}>
      {users.length > 0 && <Alert title="این بن تنها شامل کاربران زیر می باشد." />}
      {users.map((item, i) => (
        <UserCard key={i} {...item} />
      ))}
    </Stack>
  );
}

function Alert({ title }) {
  return (
    <Card sx={{ bgcolor: 'warning.lighter', mb: 1 }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'warning.lighter' }}>
            <WarningRoundedIcon color="warning" fontSize="small" />
          </Avatar>
        }
        subheader={<Typography variant="caption">{title}</Typography>}
      />
    </Card>
  );
}

function UserCard({ id, firstname, lastname, cellphone, media }) {
  const img = media[0]?.full_url || '/assets/images/picture.png';
  return (
    <Card sx={{ width: '100%' }}>
      <CardHeader
        title={
          <Typography fontSize={14} variant="subtitle1">
            {`${firstname} ${lastname}`}
          </Typography>
        }
        avatar={<Avatar sx={{ bgcolor: 'action.hover' }} src={img} />}
        // action={
        //   <IconButton color="error" disabled={loading} size="small" onClick={() => onDelete(id)}>
        //     <DeleteOutlineRounded fontSize="small" />
        //   </IconButton>
        // }
      />
    </Card>
  );
}
